export default "__VITE_ASSET__Bu2VCkUa__"